export default function ProcessIconOne() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      fill="none"
      viewBox="0 0 72 72"
    >
      <rect width="72" height="72" fill="#E6F1FE" rx="36" />
      <path
        fill="#0070F4"
        d="M18 24c0-2.188 1.75-4 4-4h10v8c0 1.125.875 2 2 2h8v7.875l-5.438 5.438a4.326 4.326 0 0 0-1.312 2.312l-1.188 4.688c-.124.562-.124 1.187.063 1.75H22c-2.25 0-4-1.813-4-4V24Zm24 4h-8v-8l8 8Zm10.313 6.75.937.938c.938.937.938 2.5 0 3.5l-1.875 1.874-4.438-4.437 1.876-1.875c.937-.938 2.562-.938 3.5 0ZM37.437 46.063 45.563 38 50 42.438 41.875 50.5c-.25.25-.563.438-.875.563L37.187 52c-.312.063-.687 0-.937-.25s-.313-.625-.25-1l.938-3.75c.062-.313.25-.688.5-.938Z"
      />
    </svg>
  )
}
